import type { AnchorStrategyModel } from '@/shared/generated'

import { Slot } from 'radix-ui'

import { ampli } from '@/shared/lib/ampli'
import { useModals } from '@/shared/lib/modal-manager'

export default function OpenStrategyTrigger({
	children,
	strategy,
}: {
	children: React.ReactNode
	strategy: AnchorStrategyModel
}) {
	const { showModal } = useModals()
	const handleOpenStrategyModal = () => {
		ampli.anchoringViewAnchorStrategy()
		showModal('ANCHOR_STRATEGY_MODAL', {
			...strategy,
		})
	}

	return <Slot.Root onClick={handleOpenStrategyModal}>{children}</Slot.Root>
}
